<template>
    <v-app>
        <market-setup
            :dialog="dialog"
            :data="data"
            @update:dialog="dialog = $event"
        />

        <v-container fluid>
            <v-row>
                <v-col cols="12">

                    <v-expansion-panels v-model="panel">

                        <v-expansion-panel>

                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Market List
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <v-row class="py-2">

                                    <v-col md="4" cols="12">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            single-line
                                            hide-details
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            class="pl-2"
                                            clearable
                                        ></v-text-field>
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                                variant="outlined"
                                                density="compact"
                                                size="x-small"
                                                divided
                                            >
                                                <v-btn
                                                    prepend-icon="mdi mdi-download"
                                                    variant="flat"
                                                    color="success"
                                                    @click="exportToCSV"
                                                >
                                                    CSV
                                                </v-btn>

                                                <v-btn
                                                    prepend-icon="mdi mdi-download"
                                                    variant="flat"
                                                    color="primary"
                                                    @click="exportToExcel"
                                                >
                                                    EXCEL
                                                </v-btn>

                                                <v-btn
                                                    prepend-icon="mdi mdi-download"
                                                    variant="flat"
                                                    color="red"
                                                    @click="exportToPDF"
                                                >
                                                    PDF
                                                </v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <div class="text-right pr-2">

                                            <v-btn
                                                v-if="$insertAccess($route.fullPath)"
                                                @click="openAddMarket"
                                                color="primary"
                                                variant="tonal"
                                                prepend-icon="mdi mdi-plus"
                                                rounded="xl"
                                            >
                                                Add Market
                                            </v-btn>

                                        </div>
                                    </v-col>

                                </v-row>

                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                >

                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <v-chip
                                            v-if="item.status == 1"
                                            color="success"
                                            size="small"
                                            class="text-capitalize"
                                        >
                                            Active
                                        </v-chip>

                                        <v-chip
                                            v-else
                                            color="red"
                                            size="small"
                                            class="text-capitalize"
                                        >
                                            Inactive
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">

                                        <v-icon
                                            class="me-2 edit-button"
                                            color="primary"
                                            @click="editItem(item)"
                                            v-if="$updateAccess($route.fullPath)"
                                        >
                                            mdi mdi-pencil-outline
                                        </v-icon>

                                    </template>

                                </v-data-table>

                            </v-expansion-panel-text>

                        </v-expansion-panel>

                    </v-expansion-panels>

                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import marketSetup from '@/components/module/sales/settingsManagement/marketSetup.vue';

export default {

    components: {
        marketSetup
    },

    data: () => ({

        itemsPerPage: 10,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,

        data: {},

        headers: [
            {
                title: "#SL",
                align: "center",
                key: "index",
                width: "7%",
                sortable: false
            },

            {
                title: "Code",
                key: "code",
                align: "left",
                sortable: false
            },

            {
                title: "Name",
                key: "name",
                align: "left",
                sortable: false
            },

            {
                title: "Status",
                align: "center",
                key: "status",
                sortable: true
            },

            {
                title: "Actions",
                align: "center",
                key: "actions",
                sortable: false
            }
        ],
    }),

    created() {

        // if (this.$store.getters.getMarketList.length == 0) {

            this.loading = true;

            this.$store.dispatch('getMarketList')

                .then(() => {
                    this.loading = false;
                })

                .catch(() => {
                    this.loading = false;
                });
        // }
    },

    computed: {

        getSchema() {
            return this.$store.getters.getMarketList;
        },

    },

    methods: {

        openAddMarket() {

            this.data = {
                market_id: '',
                name: '',
                code: '',
                status: 1,
            };

            this.dialog = true;
        },

        editItem(item) {

            this.data = { ...item };

            this.dialog = true;
        },

        exportToPDF() {

            let serialNumber = 1;

            const columns = ['#SL', 'Code', 'Name', 'Status'];

            const rows = this.getSchema.map(item => [
                serialNumber++,
                item.code,
                item.name,
                item.status == 1 ? 'Active' : 'Inactive'
            ]);

            this.$exportTableToPDF(
                columns,
                rows,
                'Market List',
                'market_list_' + this.$fileDate()
            );
        },

        exportToExcel() {

            var data = [['#SL', 'Code', 'Name', 'Status']];

            var serialNumber = 1;

            this.getSchema.forEach(item => {

                data.push([
                    serialNumber++,
                    item.code,
                    item.name,
                    item.status == 1 ? 'Active' : 'Inactive'
                ]);

            });

            this.$exportTableToExcel(
                data,
                'market_list_' + this.$fileDate()
            );
        },

        exportToCSV() {

            var data = [['#SL', 'Code', 'Name', 'Status']];

            var serialNumber = 1;

            this.getSchema.forEach(item => {

                data.push([
                    serialNumber++,
                    item.code,
                    item.name,
                    item.status == 1 ? 'Active' : 'Inactive'
                ]);

            });

            this.$exportTableToCSV(
                data,
                'market_list_' + this.$fileDate()
            );
        },
    },

    mounted() {

    }

}
</script>